import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { InternalStockItemsQuery, InternalStockItemsQueryParameter } from "../inventory/models/models";
import customerCategoriesApi from "../shared/api/customerCategoriesApi";
import customerManufacturersApi from "../shared/api/customerManufacturersApi";
import { CustomerInternalStockState } from "./models/models";
import customerInternalStockItemsApi from "../shared/api/customerInternalStockItemsApi";

export const getInternalStockItems = createAsyncThunk(
  "customerInternalStock/getInternalStockItems",
  async (query: InternalStockItemsQuery) => {
    return customerInternalStockItemsApi.getInternalStockItems(query);
  }
)

export const getCategories = createAsyncThunk(
  "customerInternalStock/getCategories",
  async () => {
    return customerCategoriesApi.getCategories();
  }
)

export const getManufacturers = createAsyncThunk(
  "customerInternalStock/getManufacturers",
  async () => {
    return customerManufacturersApi.getManufacturers();
  }
)

const initialMachineState: CustomerInternalStockState = {
  internalStockItemsQuery: {
    pageNo: 1,
    pageSize: 20,
    categoryId: undefined,
    search: undefined,
    machineId: '',
    sortBy: InternalStockItemsQueryParameter.number
  },
  categories: [],
  manufacturers: [],
  internalStockItems: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const customerInternalStockSlice = createSlice({
  name: "customerInternalStock",
  initialState: initialMachineState,
  reducers: {
    changeInternalStockItemsQuery: (state, action) => {
      state.internalStockItemsQuery = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getInternalStockItems.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInternalStockItems.fulfilled, (state, { payload }) => {
        state.internalStockItems = payload;
        state.loading = false;
      })
      .addCase(getInternalStockItems.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(getManufacturers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManufacturers.fulfilled, (state, { payload }) => {
        state.manufacturers = payload;
        state.loading = false;
      })
      .addCase(getManufacturers.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      })

    builder
      .addCase(getCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategories.fulfilled, (state, { payload }) => {
        state.categories = payload;
        state.loading = false;
      })
      .addCase(getCategories.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      })
  }
});

export const {
  changeInternalStockItemsQuery,
  setSuccess,
  setLoading,
  setError
} = customerInternalStockSlice.actions;

export default customerInternalStockSlice.reducer;
